import getSizeLib from 'get-size'
import StrictObj from './strict-obj'
import extractRawElm from './extract-raw-elm'

export default function getSize($elm) {
  const elm = extractRawElm($elm)
  const size = getSizeLib(elm)
  const proxy = StrictObj({
    width: Math.round(size.width),
    height: Math.round(size.height),
    innerWidth: Math.round(size.innerWidth),
    innerHeight: Math.round(size.innerHeight),
    outerWidth: Math.round(size.outerWidth),
    outerHeight: Math.round(size.outerHeight)
  })

  return proxy
}

export function getZeroSize() {
  return StrictObj({
    width: 0,
    height: 0,
    innerWidth: 0,
    innerHeight: 0,
    outerWidth: 0,
    outerHeight: 0
  })
}
